<template>

  <div class="box-validatecode">
    <MFAHandler v-if="MFAStatus" v-on:tokenObtained="onClickedChild"></MFAHandler>
    <modal name="additional-info" class="funding-details-modal -less-margin" width="80%" :maxWidth="420" height="auto" :scrollable="true" :adaptive="true" @before-close="modalExtraInfo = null, MFAStatus = true">
      <div class="box-funding-details">
        <h3 class="title">Información adicional:</h3>
        <div v-if="modalExtraInfo !== null">
          <div v-if="modalExtraInfo.names.length">
            <p><b>Administradores:</b></p>
            <ul>
              <li v-for="name in modalExtraInfo.names" :key="name.id">{{ name }}</li>
            </ul>
          </div>
          <p>
            <b>Fecha de información financiera</b>:
            {{ format(modalExtraInfo.created_at, 'DD/MM/YYYY') }}
          </p>
          <p><b>EBITDA</b>: {{ formatCurrency(modalExtraInfo.ebitda) }}</p>
          <p><b>Capital contable</b>: {{ formatCurrency(modalExtraInfo.accounting_capital) }}</p>
          <p v-if="modalExtraInfo.total_assets !== 0">
            <b>Activo total</b>:
            {{ formatCurrency(modalExtraInfo.total_assets) }}
          </p>
          <p><b>Pasivos totales</b>: {{ formatCurrency(modalExtraInfo.total_liabilities) }}</p>
          <p><b>Razón de liquidez</b>: {{ modalExtraInfo.liquidity }}</p>
          <p><b>Apalancamiento</b>: {{ formatPercentage(modalExtraInfo.leverage) }}</p>
          <p><b>Margen operativo</b>: {{ formatPercentage(modalExtraInfo.operating_margin) }}</p>
          <a href="#" class="close" @click.prevent="$modal.hide('additional-info')">
            <img src="/static/svg/icon_fontawesome-times-circle.svg">
          </a>
        </div>
      </div>
    </modal>
  </div>

</template>

<script>

import MFAHandler from '@/components/MFAHandler'
import { format } from 'date-fns'
import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'RequestExtraInfoValidateCode',
  data () {
    return {
      modalExtraInfo: null,
      MFAStatus: true,
      format
    }
  },
  components: {
    MFAHandler
  },
  props: { enterpriseID: Number },
  mixins: [mixins, httpRequestMixin],
  methods: {
    onClickedChild: async function (token) {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/enterprise-extra/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          'token': token,
          'enterprise_id': this.enterpriseID
        }
      }

      this.MFAStatus = true

      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
            this.modalExtraInfo = response.data.message
            this.$modal.show('additional-info')
            this.MFAStatus = false
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          case 400:
            this.modalExtraInfo = null
            break
          default:
            break
        }
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/requestDetail/RequestDetailExtraInfoValidateCode.vue